module.exports = __webpack_public_path__ + "img/Team_photo_PH2_5678_960x224.8371b991.jpg";